module.exports = __webpack_public_path__ + "img/api-introduction.511169d3.png";